export default __webpack_public_path__ + "static/media/workouttimes_2@2x.697980b4.jpg";